// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Gemeinsame Styles der produktspezifischen Tabs (Firmament, Atmos Air Quality, RadiaCode, BodySurfing) */
.custom-tab-common {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  max-width: 52rem;
}

/* Abschnitte: Linien statt Karten */
.custom-tab-section {
  padding: 1.5rem 0;
  border-top: 1px solid var(--border-primary);
}

.custom-tab-section:first-child {
  padding-top: 0;
  border-top: 0;
}

.custom-tab-heading {
  margin: 0 0 0.6rem;
  font-family: var(--font-body);
  font-size: 1.12rem;
  font-weight: 700;
  text-transform: none;
}

.custom-tab-common p {
  margin: 0 0 0.6rem;
  color: var(--text-primary);
}

.custom-tab-common p:last-child {
  margin-bottom: 0;
}

.custom-tab-common ul {
  margin: 0.25rem 0 0.75rem;
  padding-left: 1.2rem;
}

.custom-tab-common li + li {
  margin-top: 0.35rem;
}

.custom-tab-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.2fr);
  gap: 1.25rem;
  align-items: start;
  margin-top: 0.5rem;
}

.custom-tab-legend {
  font-size: 0.92rem;
  color: var(--text-secondary);
}

.custom-tab-legend p {
  margin-bottom: 0.4rem;
}

/* Bilder: Uhr-Screens auf dunklem Display-Grund */
.custom-tab-image-wrap {
  background: #050808;
  border: 1px solid var(--border-primary);
  padding: 0.5rem;
  text-align: center;
}

.custom-tab-image {
  display: block;
  max-width: 100%;
  height: auto;
  margin: 0 auto;
}

.custom-tab-poster {
  max-width: 26rem;
}

/* Hinweise im Datenfeld-Rahmen (siehe ui.css .note) */
.custom-tab-note,
.custom-tab-warning {
  --note-color: var(--accent-primary);
  position: relative;
  margin: 1rem 0 0.75rem;
  padding: 0.9rem 1rem;
  border: 1px solid var(--border-primary);
  color: var(--text-primary);
}

.custom-tab-note::after,
.custom-tab-warning::after {
  content: '';
  position: absolute;
  inset: -1px;
  pointer-events: none;
  background:
    linear-gradient(var(--note-color), var(--note-color)) top right / 12px 2px no-repeat,
    linear-gradient(var(--note-color), var(--note-color)) top right / 2px 12px no-repeat,
    linear-gradient(var(--note-color), var(--note-color)) bottom left / 12px 2px no-repeat,
    linear-gradient(var(--note-color), var(--note-color)) bottom left / 2px 12px no-repeat;
}

.custom-tab-warning {
  --note-color: var(--signal);
  border-color: color-mix(in srgb, var(--signal) 45%, var(--border-primary));
}

.custom-tab-warning p {
  margin: 0;
  font-weight: 700;
}

/* Bild + Text nebeneinander (Ansichten) */
.view-row {
  display: grid;
  grid-template-columns: minmax(0, 14rem) minmax(0, 1fr);
  gap: 1.25rem;
  align-items: start;
}

.view-row .custom-tab-image-wrap {
  padding: 0.35rem;
}

/* Listen und Tabellen */
.bodysurf-list {
  margin: 0.25rem 0 0.75rem;
  padding: 0;
  list-style: none;
  border-top: 1px solid var(--border-primary);
}

.bodysurf-list li {
  margin: 0;
  padding: 0.55rem 0;
  border-bottom: 1px solid var(--border-primary);
}

.bodysurf-list li + li {
  margin-top: 0;
}

.bodysurf-title-table {
  width: 100%;
  margin: 0.5rem 0 1rem;
  border-collapse: collapse;
  font-size: 0.95rem;
}

.bodysurf-title-table th,
.bodysurf-title-table td {
  padding: 0.5rem 0.4rem;
  border-bottom: 1px solid var(--border-primary);
  text-align: left;
  vertical-align: top;
}

.bodysurf-title-table th {
  font-family: var(--font-mono);
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--text-tertiary);
}

.custom-tab-common .guide-inline-link {
  color: var(--accent-primary);
  text-decoration: underline;
  text-underline-offset: 3px;
}

.firmament-shower-table td:last-child,
.firmament-shower-table th:last-child {
  text-align: right;
  white-space: nowrap;
  font-family: var(--font-mono);
}

.firmament-level-list strong {
  font-family: var(--font-mono);
  font-weight: 600;
}

@media (max-width: 640px) {
  .custom-tab-row,
  .view-row {
    grid-template-columns: minmax(0, 1fr);
  }

  .view-row .custom-tab-image-wrap {
    max-width: 14rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/customTabs/CustomTabCommon.css"],"names":[],"mappings":"AAAA,0GAA0G;AAC1G;EACE,aAAa;EACb,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA,oCAAoC;AACpC;EACE,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sDAAsD;EACtD,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;AACvB;;AAEA,kDAAkD;AAClD;EACE,mBAAmB;EACnB,uCAAuC;EACvC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,sDAAsD;AACtD;;EAEE,mCAAmC;EACnC,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;EACpB,uCAAuC;EACvC,0BAA0B;AAC5B;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB;;;;0FAIwF;AAC1F;;AAEA;EACE,2BAA2B;EAC3B,0EAA0E;AAC5E;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,sDAAsD;EACtD,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;EACzB,UAAU;EACV,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,sBAAsB;EACtB,8CAA8C;EAC9C,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;;EAEE,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE;;IAEE,qCAAqC;EACvC;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* Gemeinsame Styles der produktspezifischen Tabs (Firmament, Atmos Air Quality, RadiaCode, BodySurfing) */\n.custom-tab-common {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  max-width: 52rem;\n}\n\n/* Abschnitte: Linien statt Karten */\n.custom-tab-section {\n  padding: 1.5rem 0;\n  border-top: 1px solid var(--border-primary);\n}\n\n.custom-tab-section:first-child {\n  padding-top: 0;\n  border-top: 0;\n}\n\n.custom-tab-heading {\n  margin: 0 0 0.6rem;\n  font-family: var(--font-body);\n  font-size: 1.12rem;\n  font-weight: 700;\n  text-transform: none;\n}\n\n.custom-tab-common p {\n  margin: 0 0 0.6rem;\n  color: var(--text-primary);\n}\n\n.custom-tab-common p:last-child {\n  margin-bottom: 0;\n}\n\n.custom-tab-common ul {\n  margin: 0.25rem 0 0.75rem;\n  padding-left: 1.2rem;\n}\n\n.custom-tab-common li + li {\n  margin-top: 0.35rem;\n}\n\n.custom-tab-row {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1.2fr);\n  gap: 1.25rem;\n  align-items: start;\n  margin-top: 0.5rem;\n}\n\n.custom-tab-legend {\n  font-size: 0.92rem;\n  color: var(--text-secondary);\n}\n\n.custom-tab-legend p {\n  margin-bottom: 0.4rem;\n}\n\n/* Bilder: Uhr-Screens auf dunklem Display-Grund */\n.custom-tab-image-wrap {\n  background: #050808;\n  border: 1px solid var(--border-primary);\n  padding: 0.5rem;\n  text-align: center;\n}\n\n.custom-tab-image {\n  display: block;\n  max-width: 100%;\n  height: auto;\n  margin: 0 auto;\n}\n\n.custom-tab-poster {\n  max-width: 26rem;\n}\n\n/* Hinweise im Datenfeld-Rahmen (siehe ui.css .note) */\n.custom-tab-note,\n.custom-tab-warning {\n  --note-color: var(--accent-primary);\n  position: relative;\n  margin: 1rem 0 0.75rem;\n  padding: 0.9rem 1rem;\n  border: 1px solid var(--border-primary);\n  color: var(--text-primary);\n}\n\n.custom-tab-note::after,\n.custom-tab-warning::after {\n  content: '';\n  position: absolute;\n  inset: -1px;\n  pointer-events: none;\n  background:\n    linear-gradient(var(--note-color), var(--note-color)) top right / 12px 2px no-repeat,\n    linear-gradient(var(--note-color), var(--note-color)) top right / 2px 12px no-repeat,\n    linear-gradient(var(--note-color), var(--note-color)) bottom left / 12px 2px no-repeat,\n    linear-gradient(var(--note-color), var(--note-color)) bottom left / 2px 12px no-repeat;\n}\n\n.custom-tab-warning {\n  --note-color: var(--signal);\n  border-color: color-mix(in srgb, var(--signal) 45%, var(--border-primary));\n}\n\n.custom-tab-warning p {\n  margin: 0;\n  font-weight: 700;\n}\n\n/* Bild + Text nebeneinander (Ansichten) */\n.view-row {\n  display: grid;\n  grid-template-columns: minmax(0, 14rem) minmax(0, 1fr);\n  gap: 1.25rem;\n  align-items: start;\n}\n\n.view-row .custom-tab-image-wrap {\n  padding: 0.35rem;\n}\n\n/* Listen und Tabellen */\n.bodysurf-list {\n  margin: 0.25rem 0 0.75rem;\n  padding: 0;\n  list-style: none;\n  border-top: 1px solid var(--border-primary);\n}\n\n.bodysurf-list li {\n  margin: 0;\n  padding: 0.55rem 0;\n  border-bottom: 1px solid var(--border-primary);\n}\n\n.bodysurf-list li + li {\n  margin-top: 0;\n}\n\n.bodysurf-title-table {\n  width: 100%;\n  margin: 0.5rem 0 1rem;\n  border-collapse: collapse;\n  font-size: 0.95rem;\n}\n\n.bodysurf-title-table th,\n.bodysurf-title-table td {\n  padding: 0.5rem 0.4rem;\n  border-bottom: 1px solid var(--border-primary);\n  text-align: left;\n  vertical-align: top;\n}\n\n.bodysurf-title-table th {\n  font-family: var(--font-mono);\n  font-size: 0.7rem;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--text-tertiary);\n}\n\n.custom-tab-common .guide-inline-link {\n  color: var(--accent-primary);\n  text-decoration: underline;\n  text-underline-offset: 3px;\n}\n\n.firmament-shower-table td:last-child,\n.firmament-shower-table th:last-child {\n  text-align: right;\n  white-space: nowrap;\n  font-family: var(--font-mono);\n}\n\n.firmament-level-list strong {\n  font-family: var(--font-mono);\n  font-weight: 600;\n}\n\n@media (max-width: 640px) {\n  .custom-tab-row,\n  .view-row {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .view-row .custom-tab-image-wrap {\n    max-width: 14rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
